import { useCallback } from "react";

import { TimeFrameType } from "src/organization/pages/project/environment/metrics/resources/types";
import { usePoller } from "src/organization/pages/project/environment/metrics/utils/polling";
import useObservabilityPipelineHttpClient from "src/organization/pages/project/environment/observabilitySandbox/hooks/useObservabilityPipelineHttpClient";

const useHttpMetricsPoll = ({ timeFrame }: { timeFrame: TimeFrameType }) => {
  const client = useObservabilityPipelineHttpClient();

  const requestFn = useCallback(
    async () => await client?.getHttpMetricsOverview(timeFrame),
    [client, timeFrame]
  );

  return usePoller({
    requestFn,
    timeFrame
  });
};

export default useHttpMetricsPoll;
